export default __webpack_public_path__ + "static/media/modal_bg.ab2dd19c.png";